import React from "react"
import { AccordionPanel, Box, Text } from "@chakra-ui/react"

import Row from "@app/components/Migrated/Row"
import Column from "@app/components/Migrated/Column"
import StuffToolTip from "@app/components/Sections/StuffList/StuffTooltip"

type Props = {
  grossStuff: GatsbyTypes.TemplateFlexibleQuery["grossStuff"]
}

const AccordionGroupGrossStuffItem: React.FC<Props> = ({ grossStuff }) => (
  <AccordionPanel p={0}>
    <Row mt={{ base: "-10px", sm: "24px" }} mb={{ base: "60px", sm: "30px" }}>
      <Column w={{ base: "100%", sm: "37.5%" }}>
        <Box pr={{ sm: "80px" }} display={{ base: "none", sm: "block" }}>
          <Text variant="paragraph18">
            Kids products didn&apos;t meet our high standards for formulation and fun—here&apos;s what we cut out to fix that:
          </Text>
        </Box>
      </Column>
      <Column w={{ base: "100%", sm: "56.25%" }}>
        {grossStuff?.edges
          ?.map(edge => edge?.node)
          ?.map((item, index) => (
            <>
              <Box display="inline-block">
                <StuffToolTip
                  key={index}
                  index={index}
                  title={item?.title}
                  tip={item?.description}
                  strikeStyle={"thin"}
                  fontSize={{ base: 25, sm: 30 }}
                  lineHeight={{ base: 1.4, sm: "42px" }}
                />
              </Box>
              {index !== grossStuff?.length - 1 && (
                <Text fontSize={{ base: 25, sm: 30 }} lineHeight={{ base: 1.4, sm: "42px" }} display="inline-block">
                  ,&nbsp;
                </Text>
              )}
            </>
          ))}
      </Column>
    </Row>
  </AccordionPanel>
)

export default React.memo(AccordionGroupGrossStuffItem)
